import script from "./PublicProfileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicProfileLayout.vue?vue&type=script&setup=true&lang=js"

import "./PublicProfileLayout.vue?vue&type=style&index=0&id=608d56d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-608d56d4"]])

export default __exports__